function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { isMobile } from '@finect/front-utils/isMobile';
import { subscribedTo, subscribe, unsubscribe, getEntity } from './actions';
import { EntityCardContent } from './EntityCardContent';
import { processProfile, processTag, EntityCardContainer } from './partials';
export var EntityCard = function (_React$Component) {
  _inherits(EntityCard, _React$Component);
  var _super = _createSuper(EntityCard);
  function EntityCard() {
    var _this;
    _classCallCheck(this, EntityCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "timeout", void 0);
    _defineProperty(_assertThisInitialized(_this), "container", void 0);
    _defineProperty(_assertThisInitialized(_this), "state", {
      loggedIn: _this.props.loggedIn || null,
      show: false,
      entity: _this.props.entity,
      following: false,
      position: {
        x: 'bottom',
        y: 'left'
      }
    });
    _defineProperty(_assertThisInitialized(_this), "clearTimeOut", function () {
      clearTimeout(_this.timeout);
    });
    _defineProperty(_assertThisInitialized(_this), "optimisticFollow", function () {
      var newState = {};
      newState.following = true;
      if (_this.props.type === 'tag') {
        var entity = _objectSpread({}, _this.state.entity);
        entity.followers += 1;
        newState.entity = entity;
      }
      _this.setState(newState);
    });
    _defineProperty(_assertThisInitialized(_this), "optimisticUnFollow", function () {
      var newState = {};
      newState.following = false;
      if (_this.props.type === 'tag') {
        var entity = _objectSpread({}, _this.state.entity);
        entity.followers -= 1;
        newState.entity = entity;
      }
      _this.setState(newState);
    });
    _defineProperty(_assertThisInitialized(_this), "getPosition", function () {
      var position = {};
      var cardWidth = 330;
      var cardHeight = 200;
      var viewWidth = window.innerWidth;
      var viewHeight = window.innerHeight;
      var _this$container$getBo = _this.container.getBoundingClientRect(),
        top = _this$container$getBo.top,
        left = _this$container$getBo.left,
        right = _this$container$getBo.right;
      position.x = top + cardHeight < viewHeight ? 'bottom' : 'top';
      position.y = left + cardWidth < viewWidth ? 'left' : right - cardWidth > 0 ? 'right' : 'center';
      _this.setState({
        position: position
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setLoggedIn", function (response) {
      var status = response.status;
      if (typeof _this.state.loggedIn === 'boolean') return;
      _this.setState({
        loggedIn: !(status && status === 401)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getInfo", function () {
      var _this$props = _this.props,
        type = _this$props.type,
        entity = _this$props.entity;
      var loggedIn = _this.state.loggedIn;
      var promises = [];
      promises.push(getEntity(type, entity.id));
      if (typeof loggedIn !== 'boolean' || loggedIn) {
        promises.push(subscribedTo(type, entity.id, _this.setLoggedIn));
      }
      var getEntityInfo = Promise.all(promises.map(function (promise) {
        return promise.catch(function () {
          return null;
        });
      }));
      getEntityInfo.then(function (results) {
        var _results = _slicedToArray(results, 2),
          entityData = _results[0],
          subscribed = _results[1];
        if (!entityData) return _this.setState({
          following: subscribed
        });
        var newEntity;
        if (type === 'profile') {
          newEntity = processProfile(entityData);
        }
        if (type === 'tag') {
          newEntity = processTag(entityData);
        }
        if (type === 'product') {
          newEntity = _objectSpread({
            subtype: entityData.subtype
          }, entityData.entity);
        }
        if (!newEntity) return;
        _this.setState({
          entity: newEntity,
          following: subscribed
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "follow", function () {
      var _this$props2 = _this.props,
        type = _this$props2.type,
        entity = _this$props2.entity;
      var _this$state = _this.state,
        loggedIn = _this$state.loggedIn,
        following = _this$state.following;
      if (!loggedIn) {
        var blob = {
          copy: 'Accede a Finect para realizar esta acción.',
          action: 'subscribe',
          target: {
            type: type,
            id: entity.id
          }
        };
        var event = new CustomEvent('loggedAction', {
          detail: blob
        });
        window.dispatchEvent(event);
      }
      if (!following) {
        subscribe(type, entity.id, _this.optimisticUnFollow);
        return _this.optimisticFollow();
      }
      unsubscribe(type, entity.id, _this.optimisticFollow);
      return _this.optimisticUnFollow();
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      if (!_this.state.show) {
        _this.clearTimeOut();
        _this.timeout = setTimeout(function () {
          _this.getInfo();
          _this.getPosition();
          _this.setState({
            show: true
          });
        }, 100);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.clearTimeOut();
      _this.state.show && _this.setState({
        show: false
      });
    });
    return _this;
  }
  _createClass(EntityCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state2 = this.state,
        show = _this$state2.show,
        entity = _this$state2.entity,
        following = _this$state2.following,
        position = _this$state2.position;
      var _this$props3 = this.props,
        children = _this$props3.children,
        type = _this$props3.type,
        arrowPosition = _this$props3.arrowPosition;
      var eventProps = !isMobile() ? {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      } : {};
      return React.createElement(EntityCardContainer, _extends({
        ref: function ref(el) {
          return _this2.container = el;
        }
      }, eventProps), children, show && React.createElement(EntityCardContent, {
        type: type,
        entity: entity,
        follow: this.follow,
        following: following,
        position: position,
        arrowPosition: arrowPosition
      }));
    }
  }]);
  return EntityCard;
}(React.Component);